import { collection, getDocs, query, where } from "firebase/firestore";
import db from "../../config/firebase";

// initial state
const initialState = {
  username: "admin",
  password: "admin",
  success: false,
  error: true,
};

// type
const SUCCESS_LOGIN = "SUCCESS_LOGIN",
  ERROR_LOGIN = "ERROR_LOGIN";

// reducers
const loginReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SUCCESS_LOGIN":
      return {
        ...state,
        error: false,
        success: action.payload,
      };
    case "ERROR_LOGIN":
      return {
        ...state,
        success: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

// actions
export const loginAction = (user, pass) => async (dispatch, getState) => {
  const username = getState().Login.username;
  const password = getState().Login.password;
  const success = getState().Login.success;
  const error = getState().Login.error;

  // check user
  const q = query(
    collection(db, "user"),
    where("email", "==", user),
    where("password", "==", pass)
  );
  const querySnapshot = await getDocs(q);

  // check if is empty
  if(querySnapshot.empty){
    dispatch({
        type: ERROR_LOGIN,
        payload: !error,
      });
  }else{
    querySnapshot.forEach((doc) => {
      localStorage.setItem("htuser", doc.id);
      localStorage.setItem(
        "ht-fullname",
        `${doc.data().name} ${doc.data().lastname}`
      );
      localStorage.setItem(
        "ht-role",
        `${doc.data().role}`
      );

      dispatch({
          type: SUCCESS_LOGIN,
          payload: !success,
        });
    });

  }
};

// export
export default loginReducer;
